// import { CircularProgress } from "@material-ui/core";
// import React from "react";
// import { Doughnut } from "react-chartjs-2";

// export default class PieChart extends React.Component {
//   constructor(props) {
//     super(props);
//     this.state = {
//       labels: ["Entry On Time", "Late", "Not Visited"],
//       datasets: [
//         {
//           // data: [65, 59, 80],
//           // data: [this.props.entryOnTime,this.props.late,this.props.notVisited],
//           data:this.props.data,

//           backgroundColor: ["#2CE1E8", "#FF9691", "#A484FF"],
//         },
//       ],
//     };
//   }
//   componentDidMount(){
//     this.setState({
//       datasets:[{data:this.props.data,backgroundColor: ["#2CE1E8", "#FF9691", "#A484FF"],}]
//     })
//   }
//   render() {
//     return (
//       <div style={{ width: "25vw" }}>
//         {
//           this.props.loadingPichartData ? <><CircularProgress/>DoughnutDoughnutDoughnutDoughnutDoughnutDoughnutDoughnutDoughnutDoughnut</>
//         :
//         <Doughnut
//           data={{ labels: this.state.labels, datasets: this.state.datasets }}
//           height="20vh"
//           width="30vw"
//             options={{
//               // title:{
//               //   display:true,
//               //   text:'Average Rainfall per month',
//               //   fontSize:20
//               // },
//               legend:{
//                 display:true,
//                 position:'left'
//               }
//             }}
//         />}
//       </div>
//     );
//   }
// }

import React, { Component } from "react";
import Chart from "chart.js";
// import classes from "./LineGraph.module.css";
import moment from "moment";
export default class LineGraph extends Component {
  constructor(props) {
    super(props);
    this.state = {
      statusData: props.statusData,
    };
  }
  onTime = () => {
    var inQueueData = 0;
    const inQueueArray = this.state.statusData.filter(
      (data) => data.isEntryScan === true
    );
    for (var i = 0; i < inQueueArray.length; i++) {
      if (
        moment(inQueueArray[i].entryTime, "h:mm a").isBefore(
          moment(inQueueArray[i].timeAlloted, "h:mm a")
        )
      ) {
        inQueueData = inQueueData + inQueueArray[i].covisitors + 1;
      }
    }
    return inQueueData;
  };
  notVisited = () => {
    var enteredData = 0;
    const enteredArray = this.state.statusData.filter(
      (data) => data.isEntryScan === false
    );
    for (var i = 0; i < enteredArray.length; i++) {
      enteredData = enteredData + enteredArray[i].covisitors + 1;
    }
    return enteredData;
  };
  late = () => {
    var lateData = 0;
    // const entryScanFiltered = this.state.statusData.filter(
    //   (data) => data.isEntryScan === false
    // );

    for (var j = 0; j < this.state.statusData.length; j++) {
      if (this.state.statusData[j].entryTime) {
        if (
          moment(this.state.statusData[j].timeAlloted, "h:mm a").isBefore(
            moment(this.state.statusData[j].entryTime, "h:mm a")
          )
        ) {
          lateData = lateData + this.state.statusData[j].covisitors + 1;
        }
      } else if (
        moment(this.state.statusData[j].timeAlloted, "h:mm a").isBefore(
          moment()
        )
      ) {
        lateData = lateData + this.state.statusData[j].covisitors + 1;
      }
    }
    return lateData;
  };

  chartRef = React.createRef();

  componentDidMount() {
    const myChartRef = this.chartRef.current.getContext("2d");

    new Chart(myChartRef, {
      type: "doughnut",
      data: {
        labels: ["Entry On Time", "Late", "Not Visited"],
        datasets: [
          {
            data: [this.onTime(), this.late(), this.notVisited()],
            backgroundColor: ["#41FFAF", "#E7FC2B", "#A096FC"],
          },
        ],
      },
      options: {
        //Customize chart options
        // responsive: true,
        // tooltips: false,
        // elements:{
        //   line:{borderColor:"yellow"}
        // },
        legend: {
          display: true,
          position: "left",
        },
      },
    });
  }
  render() {
    return (
      <div style={{ marginTop: "1vw", width: "30vw" }}>
        <canvas id="myChart" ref={this.chartRef} />
      </div>
    );
  }
}
